const { simpleCache, client } = require('./helpers')

const simpleCacheRegistry = () => new Promise((resolve, reject) => {
    simpleCache.register('forms.options', () =>
        client.get('Carregando informações...', '/forms/options'))

    simpleCache.register('settings', () =>
        client.background().get('Carregando informações...', '/settings'))

    simpleCache.register('billing', () =>
        client.background().get('Carregando informações...', '/billing'))

    simpleCache.register('properties.options', () =>
        client.get('Carregando opções...', '/properties/search-options'))

    simpleCache.register('properties.search-options', () =>
        client.get('Carregando opções...', '/properties/search-options'))

    simpleCache.register('calendars.events.finalities', () =>
        client.background().get(null, '/calendars/events/finalities'))

    resolve()
})

module.exports = simpleCacheRegistry



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/simpleCache.js